module.exports = __webpack_public_path__ + "img/bucket.34f90033.svg";